import head from 'lodash/head';
import { DRIVER_LICENSE_ATTR, EMBARGO_EXTERNAL_ATTR } from '@yme/common/constants';
import { E_COMMERCE_ENABLED_KEY } from '@yme/common/selectors';
import { getFullPowerYAMTVariant, hasGroupingProducts } from '@yme/selectors/helpers';
import { check35KWPowerVersionExist, checkYAMTTransmissionExist, getAttributeByName, getIsNewLabelForUnitShowed, } from '@yme/utils/common';
import { STUDIO_IMAGE } from '@yme/utils/constants';
import { formatPrice } from '@yme/utils/formatPrice';
import { getPdpLinkByCategory, getProductURL, getVariantWithAvailableLowestPrise, } from '@yme/utils/product';
import { SLUG_SEPARATOR } from './constants';
export const buildRequestUrl = (urlTemplate, itemsList) => {
    const items = itemsList?.reduce((acc, item) => `${acc}"${item.slug?.trim()}",`, '').slice(0, -1);
    return urlTemplate.replace(SLUG_SEPARATOR, items);
};
export const getProducts = ({ data, iconConfig, isFilterAvailableVariant, }) => {
    return data.map((product) => {
        const isGroupingProduct = hasGroupingProducts(product);
        const groupingProductsSku = getFullPowerYAMTVariant({
            isGroupingProduct,
            data: product,
        });
        const { variants, categories, slug, type } = product;
        const masterVariant = variants.find((variant) => variant.master);
        const { variantWithLowestPrice, isLowestPriseExist } = getVariantWithAvailableLowestPrise({
            product,
            isFilterAvailableVariant,
        });
        const isSomeVariantHasStock = variants.some((variant) => Boolean(variant?.stock));
        const studioImage = variantWithLowestPrice?.images.find((image) => image.url.toLowerCase().includes(STUDIO_IMAGE));
        const title = product?.name;
        const sku = groupingProductsSku || variantWithLowestPrice?.sku || masterVariant?.sku || '';
        const price = head(variantWithLowestPrice?.prices);
        const stock = variantWithLowestPrice?.stock;
        const driverLicense = getAttributeByName(masterVariant?.attributes ?? [], DRIVER_LICENSE_ATTR) || [];
        const discount = price?.discount;
        const embargoExternal = getAttributeByName(variantWithLowestPrice?.attributes ?? [], EMBARGO_EXTERNAL_ATTR) || '';
        const eComEnabled = getAttributeByName(variantWithLowestPrice?.attributes ?? [], E_COMMERCE_ENABLED_KEY);
        return {
            title,
            image: studioImage,
            discount,
            driverLicense,
            price,
            categories,
            slug,
            stock,
            sku,
            isSomeVariantHasStock,
            eComEnabled,
            type,
            embargoExternal: Date.parse(embargoExternal),
            isLowestPriseExist,
            defaultProductData: product,
            ...(iconConfig?.isYAMTIconShowed && {
                isYAMTIconShowed: checkYAMTTransmissionExist(product),
            }),
            ...(iconConfig?.is35KWIconShowed && {
                is35KWIconShowed: check35KWPowerVersionExist(product),
            }),
            ...(iconConfig?.isNewLabelForUnitShowed && {
                isNewLabelShowed: getIsNewLabelForUnitShowed(product),
            }),
        };
    });
};
export const getCarouselData = ({ products, rootLanguage, pdpLinks, isInAuthor, handleOnClickCarouselItem, isSaleLabelNeeded, }) => products
    ?.map((item) => {
    const { price, title, image, categories, isNewLabelShowed, slug, sku, discount, embargoExternal, isLowestPriseExist, driverLicense, type, defaultProductData, isYAMTIconShowed, is35KWIconShowed, } = item;
    let link;
    const pdpLink = getPdpLinkByCategory(pdpLinks, categories);
    if (pdpLink) {
        link = getProductURL({
            path: pdpLink,
            isInAuthor,
            slug,
            sku,
        });
    }
    return {
        title,
        image: {
            src: image?.url,
        },
        link,
        isSaleLabelNeeded,
        discount: formatPrice({
            locale: rootLanguage,
            currencyName: price?.currencyCode,
            price: discount?.discountedPrice,
        }),
        price: formatPrice({
            locale: rootLanguage,
            currencyName: price?.currencyCode,
            price: price?.amount,
        }),
        driverLicense: driverLicense?.length ? driverLicense[0] : undefined,
        isYAMTIconShowed,
        is35KWIconShowed,
        isNewLabelShowed,
        sku,
        embargoExternal,
        isLowestPriseExist,
        type,
        handleLinkClickCallback: handleOnClickCarouselItem
            ? handleOnClickCarouselItem(defaultProductData)
            : undefined,
    };
})
    .filter((item) => item.link);
export const sortBySlugOrder = (slugOrder, productData) => {
    const sortedItems = [...productData];
    sortedItems?.sort((a, b) => {
        const aIndex = slugOrder?.findIndex((slugItem) => slugItem.slug === a.slug);
        const bIndex = slugOrder?.findIndex((slugItem) => slugItem.slug === b.slug);
        if (aIndex === -1 || bIndex === -1) {
            // If the indices are not found, then move the elements to the end of the array
            return aIndex === -1 ? 1 : -1;
        }
        return aIndex - bIndex;
    });
    return sortedItems;
};
